import { useEffect } from 'react';
import { useModuleConfigForm } from '../../../../../utils/hooks/useModuleConfigForm';
import { FormValues } from './types';
import { configAdapter, submitAdapter } from './adapters';
import { validationSchema } from './validation';

export const useForm = ({ moduleId }) => {
  const { isInitialized, requestSubmit, formContext } =
    useModuleConfigForm<FormValues>(moduleId, {
      validationSchema,
      configAdapter,
      submitAdapter,
      subpath: '/invite',
    });

  const { register } = formContext;
  useEffect(() => {
    register('options');
  }, [register]);

  return { isInitialized, requestSubmit, formContext };
};
